import { getDayFromState } from 'modules/schedule/store/utils/get-day-from-state';
import { ScheduleSliceState } from '../index';

export const clearSelectedDay = (state: ScheduleSliceState) => {
  const weekDay = getDayFromState(state, new Date(state.selectedDate));
  if (weekDay) weekDay.isSelected = false;
};
